const SDK_VERSION = "11.2.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
